<template>
  <div class="wrap">
    <div class="fixClass" v-if="dingFlag" @click="ding">
      <img src="../../public/img/ding.png" alt />
    </div>
    <div class="header">
      <!-- <div class="zoomImage" style="background-image: url(../../public/img/banner.png)"></div> -->
      <!-- <img src="../../public/img/banner.png" alt /> -->
    </div>
    <div class="mainBox">
      <div class="searchBox">
        <el-input
          placeholder="请输入地区名称"
          v-model="input3"
          class="input-with-select"
          @input="inputCli"
          @blur="blurCli"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="souCli"
          ></el-button>
        </el-input>
        <div class="serListBox" v-if="inpFlag">
          <p @click="pCli">asdadsdasd</p>
          <p>asdadsdasd</p>
          <p>asdadsdasd</p>
          <p>asdadsdasd</p>
        </div>
      </div>
      <div class="navBox">
        <el-row :gutter="0">
          <el-col
            :span="6"
            v-for="(item, index) in navList.navOne"
            :key="index"
          >
            <div class="grid-content bg-purple el-span">
              <span style="font-weight:bolder;">{{ item.first }}</span>
              <span
                style="margin-left:10px;cursor:pointer"
                :class="{ active: v.ig == code }"
                v-for="(v, i) in item.tent"
                :key="i"
                @click="cityCli(v.name)"
                >{{ v.name }}</span
              >
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col
            :span="12"
            v-for="(item, index) in navList.navTwo"
            :key="index"
          >
            <div class="grid-content bg-purple el-span">
              <span style="font-weight:bolder;">{{ item.first }}</span>
              <span
                style="margin-left:10px;cursor:pointer"
                :class="{ active: v.ig == code }"
                v-for="(v, i) in item.tent"
                :key="i"
                @click="cityCli(v.name)"
                >{{ v.name }}</span
              >
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col
            :span="6"
            v-for="(item, index) in navList.navThree"
            :key="index"
          >
            <div class="grid-content bg-purple el-span">
              <span style="font-weight:bolder;">{{ item.first }}</span>
              <span
                style="margin-left:10px;cursor:pointer"
                :class="{ active: v.ig == code }"
                v-for="(v, i) in item.tent"
                :key="i"
                @click="cityCli(v.name)"
                >{{ v.name }}</span
              >
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col
            :span="12"
            v-for="(item, index) in navList.navFive"
            :key="index"
          >
            <div class="grid-content bg-purple el-span">
              <span style="font-weight:bolder;">{{ item.first }}</span>
              <span
                style="margin-left:10px;cursor:pointer"
                :class="{ active: v.ig == code }"
                v-for="(v, i) in item.tent"
                :key="i"
                @click="cityCli(v.name)"
                >{{ v.name }}</span
              >
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col
            :span="12"
            v-for="(item, index) in navList.navSixs"
            :key="index"
          >
            <div class="grid-content bg-purple el-span">
              <span style="font-weight:bolder;">{{ item.first }}</span>
              <span
                style="margin-left:10px;cursor:pointer"
                :class="{ active: v.ig == code }"
                v-for="(v, i) in item.tent"
                :key="i"
                @click="cityCli(v.name)"
                >{{ v.name }}</span
              >
            </div>
          </el-col>
          <el-col
            :span="6"
            v-for="(item, index) in navList.navSix"
            :key="index"
          >
            <div class="grid-content bg-purple el-span">
              <span style="font-weight:bolder;">{{ item.first }}</span>
              <span
                style="margin-left:10px;cursor:pointer"
                :class="{ active: v.ig == code }"
                v-for="(v, i) in item.tent"
                :key="i"
                @click="cityCli(v.name)"
                >{{ v.name }}</span
              >
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="content" ref="content">
        <div class="souBox" v-if="sflag">
          <div class="city_box" v-for="(item, index) in sData" :key="index">
            <div class="title">{{ item.name }}</div>
            <div class="itemBox" v-for="(ite, idx) in item.contains" :key="idx">
              <div class="tit_left">
                <b style="font-size:12px;">●</b>
                &nbsp;&nbsp;
                <span>{{ ite.name }}</span>
              </div>
              <div class="table">
                <div v-for="(v, index) in ite.contains" :key="index">
                  <p style="padding-left:25px;width:180px;">{{ v.name }}</p>
                  <p style="width:350px;font-size:13px;color:#666;">
                    <span
                      style="padding-right:20px;"
                      v-for="(t, i) in v.phoneNumber"
                      :key="i"
                      >{{ t }}</span
                    >
                  </p>
                  <p>
                    <el-tag
                      type="danger"
                      style="margin-right:10px;"
                      size="medium"
                      v-for="(n, i) in v.onLineTime"
                      :key="i"
                    >
                      <span>{{ n }}</span>
                    </el-tag>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content_box" v-if="qflag">
          <div class="city_box" v-for="(item, index) in phoneNum" :key="index">
            <div class="title">{{ item.name }}</div>
            <div class="itemBox" v-for="(ite, idx) in item.contains" :key="idx">
              <div class="tit_left">
                <b>●</b>
                &nbsp;&nbsp;
                <span>{{ ite.name }}</span>
              </div>
              <div class="table">
                <div
                  class="tItem"
                  v-for="(v, index) in ite.contains"
                  :key="index"
                >
                  <p class="p1" style="padding-left:25px;width:180px;">
                    {{ v.name }}
                  </p>
                  <p style="width:350px;font-size:13px;color:#666;">
                    <span
                      style="padding-right:20px;"
                      v-for="(t, i) in v.phoneNumber"
                      :key="i"
                      >{{ t }}</span
                    >
                  </p>
                  <p>
                    <el-tag
                      type="danger"
                      style="margin-right:10px;"
                      size="medium"
                      v-for="(n, i) in v.onLineTime"
                      :key="i"
                    >
                      <span>{{ n }}</span>
                    </el-tag>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </el-main> -->
  </div>
</template>
<script>
import {
  navOne,
  navTwo,
  navThree,
  navFour,
  navFive,
  navSixs,
  navSix
} from "@/mock/navCity";
import { cityNum } from "@/mock/saveNumber";
export default {
  name: "IFloor",
  data() {
    return {
      inpFlag: false,
      dingFlag: false,
      qflag: true,
      sflag: false,
      showHeader: false,
      code: 0,
      input3: "",
      navList: {
        navOne,
        navTwo,
        navThree,
        navFour,
        navFive,
        navSixs,
        navSix
      },
      sData: [],
      phoneNum: cityNum.slice(0, 1),
      phoneNums: cityNum,
      cityArr: [
        "安徽省",
        "北京市",
        "重庆市",
        "福建省",
        "甘肃省",
        "广东省",
        "广西壮族自治区",
        "贵州省",
        "海南省",
        "河北省",
        "黑龙江省",
        "河南省",
        "湖北省",
        "湖南省",
        "江苏省",
        "江西省",
        "吉林省",
        "辽宁省",
        "内蒙古自治区",
        "宁夏回族自治区",
        "青海省",
        "山东省",
        "上海市",
        "山西省",
        "陕西省",
        "四川省",
        "天津市",
        "新疆兵团",
        "新疆维吾尔自治区",
        "西藏自治区",
        "云南省",
        "浙江省"
      ],
      idx: 0,
      timer: null,
      childList: [],
      titList: [],
      zJie: null
    };
  },
  //   235018
  created() {
    this.$axios
      .get("/answer/answer/search")
      .then(res => {
        console.log(res);
      })
      .catch(err => {
        return err;
      });
  },
  mounted() {
    this.childList = document.querySelectorAll(".tItem");
    this.titList = document.querySelectorAll(".tit_left");
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {},
  methods: {
    //   搜索
    souCli() {
      if (this.input3.indexOf("省") || this.input3.indexOf("自治区")) {
        this.sData = this.phoneNums.filter(item => {
          if (item.name == this.input3) {
            return item;
          }
        });
      }

      if (
        this.input3.indexOf("县") ||
        this.input3.indexOf("州") ||
        this.input3.indexOf("区")
      ) {
        let fu = document.querySelector(".content");
        console.log(fu);
        this.childList.forEach(item => {
          if (item.firstChild.innerHTML == this.input3) {
            item.style.background = "#ff0";
            fu.appendChild(item.parentNode.parentNode.parentNode.firstChild);
            fu.appendChild(item.parentNode.parentNode);
          }
        });
      }
      if (this.input3.indexOf("市")) {
        let fu = document.querySelector(".content");
        // console.log(fu);
        this.titList.forEach(item => {
          console.log(item.lastChild.innerHTML);
          if (item.lastChild.innerHTML == this.input3) {
            fu.appendChild(item.parentNode.parentNode.firstChild);
            fu.appendChild(item.parentNode);
          }
        });
      }

      if (this.data == []) {
        this.$message.error("您输入的地区名称有误！");
      }
      this.sflag = true;
      this.qflag = false;
    },
    //  省
    cityCli(v) {
      this.idx = this.cityArr.findIndex(item => item == v);
      this.code = this.idx;
      this.sData = this.phoneNums.filter(item => item.name == v);
      this.sflag = true;
      this.qflag = false;
    },
    // 置顶
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 700) {
        this.dingFlag = true;
      } else {
        this.dingFlag = false;
      }
    },
    ding() {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    },
    // 实时搜索
    inputCli() {
      this.inpFlag = true;
    },
    // 失去焦点
    blurCli() {
      this.inpFlag = false;
    },
    pCli() {}
  }
};
</script>

<style scoped lang="scss">
// .el-table__footer-wrapper,
// .el-table >>> .el-table__header-wrapper {
//   display: none !important;
// }
.wrap {
  width: 100%;
  position: relative;
  .fixClass {
    width: 50px;
    height: 50px;
    position: fixed;
    bottom: 50px;
    right: 50px;
    z-index: 1000;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .header {
    width: 100%;
    height: 260px;
    margin-bottom: 20px;
    background: url("../../public/img/banner.png") no-repeat center center;
    background-size: cover;
    // img {
    //   width: 100%;
    //   height: auto;
    //   max-height: 100%;
    // }
  }
  .mainBox {
    width: 1200px;
    margin: 0 auto;
    .searchBox {
      width: 800px;
      margin: 0 auto;
      position: relative;
      .serListBox {
        width: 742px;
        background: #fff;
        // box-shadow: 0 3px 1px 3px #ccc;
        position: absolute;
        left: 0;
        top: 40px;
        z-index: 100;
        p {
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          padding-left: 15px;
        }
      }
    }
    .navBox {
      margin: 20px auto;
      width: 1050px;
      height: 300px;
      .el-row {
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
        }
      }
      .el-col {
        border-radius: 4px;
      }
      .bg-purple-dark {
        // background: #99a9bf;
      }
      .bg-purple {
        // background: #d3dce6;
      }
      .bg-purple-light {
        background: #e5e9f2;
      }
      .grid-content {
        border-radius: 4px;
        min-height: 36px;
      }
      .row-bg {
        padding: 10px 0;
        background-color: #f9fafc;
      }
      .el-span {
        line-height: 36px;
        height: 36px;
        padding-left: 10px;
      }
    }
    .content {
      width: 100%;
      height: auto;
      .title {
        width: 1050px;
        margin: 0 auto;
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-size: 20px;
        font-weight: bolder;
        color: #fff;
        background: #ff5555;
      }
      .itemBox {
        width: 1050px;
        margin: 0 auto;
        .tit_left {
          b {
            color: #f00;
          }
          height: 30px;
          line-height: 30px;
          padding-left: 10px;
          font-size: 14px;
          background: #ffcccc;
        }
        .table {
          div {
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            p {
              display: inline-block;
            }
          }
        }
      }
      //   overflow-y: scroll;
      .content_box {
        .city_box {
          .title {
            width: 1050px;
            margin: 0 auto;
            height: 50px;
            line-height: 50px;
            text-align: center;
            font-size: 20px;
            font-weight: bolder;
            color: #fff;
            background: #ff5555;
          }
          .itemBox {
            width: 1050px;
            margin: 0 auto;
            .tit_left {
              b {
                color: #f00;
              }
              height: 30px;
              line-height: 30px;
              padding-left: 10px;
              font-size: 14px;
              background: #ffcccc;
            }
            .table {
              div {
                height: 40px;
                line-height: 40px;
                font-size: 14px;
                p {
                  display: inline-block;
                }
              }
            }
          }
        }
      }
      .souBox {
        .title {
          width: 1050px;
          margin: 0 auto;
          height: 50px;
          line-height: 50px;
          text-align: center;
          font-size: 20px;
          font-weight: bolder;
          color: #fff;
          background: #ff5555;
        }
        .itemBox {
          width: 1050px;
          margin: 0 auto;
          .tit_left {
            b {
              color: #f00;
            }
            height: 30px;
            line-height: 30px;
            padding-left: 10px;
            font-size: 14px;
            background: #ffcccc;
          }
          .table {
            div {
              height: 40px;
              line-height: 40px;
              font-size: 14px;
              p {
                display: inline-block;
              }
            }
          }
        }
      }
    }
  }
}
.active {
  color: #f00 !important;
}
</style>
